import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { HousingStockGrowthRecord } from './useHousingStockGrowthData';
import { Place } from '@/types';

interface PeerHousingStockGrowthData {
  [key: string]: HousingStockGrowthRecord[]; // key is place_fips
}

export function usePeerHousingStockGrowthData(peers: Place[]) {
  const [data, setData] = useState<PeerHousingStockGrowthData>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!peers.length) {
      setLoading(false);
      setData({});
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Create an array of promises for each peer
    const fetchPromises = peers.map(peer =>
      supabase
        .from('acs_bps_housing_stock_growth')
        .select('*')
        .eq('Place', peer.name)
        .eq('place_fips', peer.place_fips)
        .order('year', { ascending: false })
        .limit(1) // We only need the most recent year for ranking
    );

    Promise.all(fetchPromises)
      .then(results => {
        const newData: PeerHousingStockGrowthData = {};
        let loggedAny = false;
        results.forEach((result, index) => {
          if (result.error) {
            console.error(`Error fetching data for peer ${peers[index].name}:`, result.error);
          } else {
            const peerData = result.data || [];
            newData[peers[index].place_fips] = peerData;
            // Log the housing stock growth data for this peer
            const latestData = peerData[0];
            if (latestData) {
              loggedAny = true;
              console.log(`Peer City: ${peers[index].name}`);
              console.log(`  FIPS: ${peers[index].place_fips}`);
              console.log(`  Housing Stock Growth: ${latestData.housing_stock_growth_if_permits_built_instantly?.toFixed(2)}%`);
              console.log(`  Year: ${latestData.year}`);
            }
          }
        });
        if (loggedAny) {
          console.log('------------------------');
        }
        setData(newData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching peer housing stock growth data:', err);
        setError('Failed to fetch peer data');
        setLoading(false);
      });
  }, [peers]);

  return { data, loading, error };
} 